/* Suitality cart, pro additions (17 Oct 2026): cart attributes, VAT check, add from supplier, quick order, share link, saved lists. Loaded by sections/suitality-cart.liquid. */
(function () {
  if (window.__sCartPro) return;
  window.__sCartPro = true;
  var LKEY = 'suitality.lists.v1';
  var state = null;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(t) {
    var el = $('.s-toast'); if (!el) { el = document.createElement('div'); el.className = 's-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = t; el.hidden = false; clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 4500);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); });
  }
  function reloadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if ($('[data-s-cart] .s-cart__grid') && window.__sCartRefresh) return window.__sCartRefresh(c.item_count); window.location.href = '/cart';
    });
  }
  function cartItems() { var d = $('[data-s-cart-items]'); try { return d ? JSON.parse(d.textContent) : []; } catch (e) { return []; } }
  function addItems(items) {
    if (!items.length) return Promise.resolve({ added: 0, failed: [] });
    return post('/cart/add.js', { items: items }).then(function () { return { added: items.length, failed: [] }; }).catch(function () {
      var added = 0, failed = [];
      return items.reduce(function (p, it) { return p.then(function () { return post('/cart/add.js', { items: [it] }).then(function () { added++; }).catch(function (e) { failed.push({ it: it, msg: e.message }); }); }); }, Promise.resolve())
        .then(function () { return { added: added, failed: failed }; });
    });
  }

  /* Cart attributes */
  function collect() {
    var a = {};
    $$('[data-s-attrs] [data-s-attr]').forEach(function (el) { var m = el.name.match(/^attributes\[(.+)\]$/); if (m) a[m[1]] = el.value.trim(); });
    return a;
  }
  var saveT;
  function save() { clearTimeout(saveT); saveT = setTimeout(function () { state = collect(); post('/cart/update.js', { attributes: state }).catch(function () {}); }, 350); }
  function syncWhen() {
    var on = $('[data-s-when]:checked'), date = $('[data-s-when-date]'), val = $('[data-s-when-val]');
    if (!on || !date || !val) return;
    var isDate = on.value === 'date';
    date.hidden = !isDate;
    val.value = isDate ? (date.value || '') : 'As soon as possible';
    var sum = $('[data-s-when-sum]');
    if (sum) sum.textContent = isDate ? (date.value ? 'By ' + new Date(date.value + 'T12:00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : 'On a date') : 'As soon as possible';
  }
  function syncRec() { var v = $('[data-s-rec-val]'); if (v) v.value = $$('[data-s-rec]:checked').map(function (c) { return c.value; }).join('; '); }
  function applyState() {
    if (!state) return;
    $$('[data-s-attrs] [data-s-attr]').forEach(function (el) { var m = el.name.match(/^attributes\[(.+)\]$/); if (m && state[m[1]] != null) el.value = state[m[1]]; });
    var w = state['Delivery wanted by'];
    if (w != null) { var isDate = w !== 'As soon as possible'; $$('[data-s-when]').forEach(function (r) { r.checked = (r.value === 'date') === isDate; }); var d = $('[data-s-when-date]'); if (d) { d.hidden = !isDate; if (isDate) d.value = w; } }
    var rec = state['Reception']; if (rec != null) $$('[data-s-rec]').forEach(function (c) { c.checked = rec.split('; ').indexOf(c.value) > -1; });
    syncWhen();
    vat(false);
  }

  /* EU VAT number: format check, then VIES when the browser can reach it */
  var VAT = { AT: /^U\d{8}$/, BE: /^[01]\d{9}$/, BG: /^\d{9,10}$/, CY: /^\d{8}[A-Z]$/, CZ: /^\d{8,10}$/, DE: /^\d{9}$/, DK: /^\d{8}$/, EE: /^\d{9}$/, EL: /^\d{9}$/, ES: /^[A-Z0-9]\d{7}[A-Z0-9]$/, FI: /^\d{8}$/, FR: /^[A-Z0-9]{2}\d{9}$/, HR: /^\d{11}$/, HU: /^\d{8}$/, IE: /^\d[A-Z0-9+*]\d{5}[A-Z]{1,2}$/, IT: /^\d{11}$/, LT: /^(\d{9}|\d{12})$/, LU: /^\d{8}$/, LV: /^\d{11}$/, MT: /^\d{8}$/, NL: /^\d{9}B\d{2}$/, PL: /^\d{10}$/, PT: /^\d{9}$/, RO: /^\d{2,10}$/, SE: /^\d{12}$/, SI: /^\d{8}$/, SK: /^\d{10}$/, XI: /^(\d{9}|\d{12})$/ };
  var DEF = 'With a valid EU VAT number, VAT can be reverse charged at checkout, depending on the delivery country.';
  var vatSeq = 0;
  function vat(remote) {
    var el = $('[data-s-vat]'), msg = $('[data-s-vat-msg]'); if (!el || !msg) return;
    var v = el.value.toUpperCase().replace(/[\s.\-]/g, '');
    if (v.indexOf('GR') === 0) v = 'EL' + v.slice(2);
    if (el.value && v !== el.value) el.value = v;
    msg.className = 's-f__msg';
    if (!v) { msg.textContent = DEF; return; }
    var cc = v.slice(0, 2), num = v.slice(2);
    if (!VAT[cc]) { msg.classList.add('is-bad'); msg.textContent = 'Start with the country code, for example FR, DE, NL or IT.'; return; }
    if (!VAT[cc].test(num)) { msg.classList.add('is-bad'); msg.textContent = 'This does not look like a ' + cc + ' VAT number. Check the digits.'; return; }
    msg.textContent = 'Format is correct. The number is checked again at checkout.';
    if (!remote) return;
    var seq = ++vatSeq, ctl = window.AbortController ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 6000);
    fetch('https://ec.europa.eu/taxation_customs/vies/rest-api/ms/' + cc + '/vat/' + encodeURIComponent(num), ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (seq !== vatSeq) return;
        if (j.isValid === true) { msg.classList.add('is-ok'); msg.textContent = 'Valid in the EU VIES register' + (j.name && j.name !== '---' ? ': ' + j.name : '') + '.'; }
        else if (j.isValid === false && !j.userError) { msg.classList.add('is-bad'); msg.textContent = 'Not found in the EU VIES register. Check the number or leave it empty.'; }
      }).catch(function () {});
  }

  /* Saved lists (this browser) */
  function lists() { try { var v = JSON.parse(localStorage.getItem(LKEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function setLists(l) { try { localStorage.setItem(LKEY, JSON.stringify(l)); } catch (e) { toast('This browser does not allow saving lists.'); } }
  function renderLists() {
    var l = lists();
    $$('[data-s-lists]').forEach(function (box) {
      box.hidden = !l.length;
      box.innerHTML = l.length ? '<p class="s-lists__h">Saved lists</p><ul role="list">' + l.map(function (x, i) {
        var n = x.items.length, d = new Date(x.date);
        return '<li><span>' + esc(x.name) + '<small>' + n + (n === 1 ? ' product' : ' products') + ' · saved ' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) + '</small></span><div><button type="button" data-s-list-add="' + i + '">Add to cart</button><button type="button" data-s-list-del="' + i + '" aria-label="Delete the list ' + esc(x.name) + '">Delete</button></div></li>';
      }).join('') + '</ul>' : '';
    });
  }

  /* Quick order by reference */
  var prodCache = {};
  function product(handle) { if (!prodCache[handle]) prodCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return prodCache[handle]; }
  function findSku(sku) {
    var want = sku.toUpperCase();
    return fetch('/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku,title', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        return ps.reduce(function (p, x) { return p.then(function (found) { if (found) return found; return product(x.handle).then(function (pr) { if (!pr) return null; var v = pr.variants.filter(function (v) { return (v.sku || '').toUpperCase() === want; })[0]; return v ? { id: v.id, title: pr.title } : null; }); }); }, Promise.resolve(null));
      }).catch(function () { return null; });
  }
  function parseLines(text) {
    return text.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean).map(function (l) {
      var p = l.split(/[;\t]+|,(?=\s*\d+\s*$)|\s{2,}|\s(?=\d+$)/).map(function (x) { return x.trim().replace(/^"|"$/g, ''); }).filter(Boolean);
      return { sku: p[0], qty: parseInt(p[1], 10) };
    }).filter(function (x, i) { return x.sku && !(i === 0 && isNaN(x.qty) && /sku|ref/i.test(x.sku)); }).map(function (x) { x.qty = x.qty > 0 ? x.qty : 1; return x; }).slice(0, 60);
  }
  function quick(box) {
    var ta = $('[data-s-quick-text]', box), out = $('[data-s-quick-out]', box), btn = $('[data-s-quick-go]', box);
    var rows = parseLines(ta.value);
    if (!rows.length) { out.className = 's-quick__out is-bad'; out.textContent = 'Enter one reference per line, followed by the quantity.'; ta.focus(); return; }
    btn.disabled = true; out.className = 's-quick__out'; out.textContent = 'Looking up ' + rows.length + (rows.length === 1 ? ' reference…' : ' references…');
    var items = [], missing = [];
    rows.reduce(function (p, r) { return p.then(function () { return findSku(r.sku).then(function (f) { if (f) items.push({ id: f.id, quantity: r.qty }); else missing.push(r.sku); }); }); }, Promise.resolve())
      .then(function () { return addItems(items); })
      .then(function (res) {
        btn.disabled = false;
        var t = res.added ? res.added + (res.added === 1 ? ' line added to the cart.' : ' lines added to the cart.') : 'Nothing was added.';
        if (missing.length) t += ' Not found: ' + missing.join(', ') + '.';
        if (res.failed.length) t += ' Not added: ' + res.failed.map(function (f) { return f.msg; }).join(' ');
        if (res.added) { ta.value = ''; return reloadCart().then(function () { var o = $('[data-s-quick-out]'); if (o) { o.className = 's-quick__out' + (missing.length || res.failed.length ? ' is-bad' : ' is-ok'); o.textContent = t; var d = o.closest('details'); if (d) d.open = true; } }); }
        out.className = 's-quick__out is-bad'; out.textContent = t;
      }).catch(function () { btn.disabled = false; out.className = 's-quick__out is-bad'; out.textContent = 'Something went wrong. Try again.'; });
  }

  /* Shared cart link: /cart?items=variant:qty,variant:qty */
  function sharedBar() {
    var q = new URLSearchParams(location.search).get('items'); if (!q) return;
    var items = q.split(',').map(function (x) { var a = x.split(':'); return { id: parseInt(a[0], 10), quantity: Math.max(1, parseInt(a[1], 10) || 1) }; }).filter(function (x) { return x.id > 0; }).slice(0, 100);
    if (!items.length) return;
    var wrap = $('[data-s-cart] .s-wrap'); if (!wrap) return;
    var has = cartItems().length > 0;
    var bar = document.createElement('div'); bar.className = 's-sharebar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Shared cart');
    bar.innerHTML = '<p style="margin:0">A cart with ' + items.length + (items.length === 1 ? ' product' : ' products') + ' was shared with you.</p><div>' +
      (has ? '<button type="button" class="btn" data-s-shared="add">Add to my cart</button><button type="button" class="btn btn--secondary" data-s-shared="replace">Replace my cart</button>' : '<button type="button" class="btn" data-s-shared="add">Load these products</button>') +
      '<button type="button" class="btn btn--secondary" data-s-shared="no">Ignore</button></div>';
    wrap.insertBefore(bar, wrap.firstChild);
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s-shared]'); if (!b) return;
      var mode = b.getAttribute('data-s-shared');
      if (mode === 'no') { history.replaceState(null, '', '/cart'); bar.remove(); return; }
      $$('button', bar).forEach(function (x) { x.disabled = true; });
      (mode === 'replace' ? post('/cart/clear.js') : Promise.resolve()).then(function () { return addItems(items); }).then(function (res) {
        if (res.failed.length) sessionStorage.setItem('s-toast', res.failed.length + ' shared products could not be added (no longer available or below the minimum quantity).');
        window.location.href = '/cart';
      });
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.matches('[data-s-when]')) { syncWhen(); if (t.value === 'date') { var d = $('[data-s-when-date]'); if (d) d.focus(); } save(); return; }
    if (t.matches('[data-s-when-date]')) { syncWhen(); save(); return; }
    if (t.matches('[data-s-rec]')) { syncRec(); save(); return; }
    if (t.matches('[data-s-attrs] [data-s-attr]')) { if (t.matches('[data-s-vat]')) vat(true); save(); return; }
    if (t.matches('[data-s-quick-file]') && t.files && t.files[0]) {
      var box = t.closest('[data-s-quick]'), rd = new FileReader();
      rd.onload = function () { $('[data-s-quick-text]', box).value = String(rd.result || '').trim(); $('[data-s-quick-out]', box).textContent = 'File loaded. Check the lines, then add them to the cart.'; };
      rd.readAsText(t.files[0]);
    }
  });
  document.addEventListener('input', function (e) { var t = e.target; if (t.matches && t.matches('[data-s-attrs] [data-s-attr]')) save(); });
  document.addEventListener('focusout', function (e) { var t = e.target; if (t.matches && t.matches('[data-s-vat]')) vat(true); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var add = t.closest('[data-s-add]');
    if (add) {
      add.disabled = true; add.textContent = 'Adding…';
      post('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-s-add'), 10), quantity: 1 }] })
        .then(function () { toast('Added to the cart'); return reloadCart(); })
        .catch(function (err) { add.disabled = false; add.textContent = 'Add'; toast(err.message); });
      return;
    }
    var go = t.closest('[data-s-quick-go]'); if (go) { quick(go.closest('[data-s-quick]')); return; }
    var sb = t.closest('[data-s-share]');
    if (sb) {
      var items = cartItems(); if (!items.length) return;
      var url = location.origin + '/cart?items=' + items.map(function (i) { return i.id + ':' + i.qty; }).join(',');
      var lab = sb.querySelector('[data-s-share-label]'), svg = sb.querySelector('svg');
      if (!sb._svg) sb._svg = svg.innerHTML;
      var done = function () {
        sb.classList.remove('is-done'); void sb.offsetWidth; sb.classList.add('is-done');
        if (lab) lab.textContent = 'Link copied';
        svg.innerHTML = '<path d="M5 12.5l4.5 4.5L19 7.5"/>';
        toast('Link copied. It loads these products into the cart of whoever opens it.');
        clearTimeout(sb._t); sb._t = setTimeout(function () { sb.classList.remove('is-done'); if (lab) lab.textContent = 'Copy a link to this cart'; svg.innerHTML = sb._svg; }, 2500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { toast(url); }); else toast(url);
      return;
    }
    var so = t.closest('[data-s-save-open]');
    if (so) { var box = $('[data-s-save]'); var open = box.hidden; box.hidden = !open; so.setAttribute('aria-expanded', String(open)); if (open) $('[data-s-save-name]').focus(); return; }
    if (t.closest('[data-s-save-go]')) {
      var nm = $('[data-s-save-name]'), its = cartItems(); if (!its.length) return;
      var name = (nm.value || '').trim() || 'List of ' + new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      var l = lists(); l.unshift({ name: name, date: Date.now(), items: its.map(function (i) { return { id: i.id, qty: i.qty, title: i.title }; }) }); setLists(l.slice(0, 20));
      nm.value = ''; $('[data-s-save]').hidden = true; var o2 = $('[data-s-save-open]'); if (o2) o2.setAttribute('aria-expanded', 'false');
      renderLists(); toast('Saved as "' + name + '"'); return;
    }
    var la = t.closest('[data-s-list-add]');
    if (la) {
      var x = lists()[+la.getAttribute('data-s-list-add')]; if (!x) return;
      la.disabled = true;
      addItems(x.items.map(function (i) { return { id: i.id, quantity: i.qty }; })).then(function (res) {
        if (res.failed.length) sessionStorage.setItem('s-toast', res.failed.length + ' products from the list could not be added.');
        window.location.href = '/cart';
      });
      return;
    }
    var ld = t.closest('[data-s-list-del]');
    if (ld) { var l2 = lists(); l2.splice(+ld.getAttribute('data-s-list-del'), 1); setLists(l2); renderLists(); return; }
  });
  document.addEventListener('s-cart:refreshed', function () { applyState(); renderLists(); });
  function init() {
    renderLists(); sharedBar(); vat(false);
    var m = sessionStorage.getItem('s-toast'); if (m) { sessionStorage.removeItem('s-toast'); toast(m); }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
